module.exports = __webpack_public_path__ + "img/logo-full.bc22466d.svg";